export default function userSession(data) {
  if (process.env.NODE_ENV === "development") {
    window.sessionStorage.setItem("nv_user", JSON.stringify({ name: "Emman" }));
  } else if (data) {
    window.sessionStorage.setItem("nv_user", JSON.stringify(data));
  }
  if (window.sessionStorage.getItem("nv_user")) {
    return JSON.parse(window.sessionStorage.getItem("nv_user"));
  }
}

export function deleteSession() {
  window.sessionStorage.clear("nv_user");
}
